import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

export const SearchHeaderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  paddingBottom: theme.spacing(1.5),
  gap: theme.spacing(1),
}));

export const SearchHeaderTitle = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
}));

export const SearchHeaderText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const SearchHeaderLink = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  paddingRight: theme.spacing(2),
  cursor: 'pointer',
}));

export const SearchHeaderLinkText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.mds_global_color_teal,
  fontSize: '14px',
  lineHeight: theme.spacing(3),
  fontWeight: 700,
  textDecoration: 'underline',
}));

export const TitleIconContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginRight: theme.spacing(1),
  alignItems: 'center',
}));
